"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _RoutesProvider = require("../components/RoutesProvider");

/**
 * Returns all of the declared routes within an app.
 */
var useRoutes = function useRoutes() {
  var routes = (0, _react.useContext)(_RoutesProvider.RoutesContext);
  return routes;
};

var _default = useRoutes;
exports["default"] = _default;